import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 32,
    fontWeight: 400,
    lineHeight: 1,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: '#192542',
  },
  tabs: {
    borderBottom: '1px solid #d8d8d8',
    marginBottom: 16,
  },
  tab: {
    minWidth: 110,
  },
}));
